/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ updated: NonNullable<unknown> }} Cases_Timeline_UpdatedInputs */

const en_cases_timeline_updated = /** @type {(inputs: Cases_Timeline_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.updated}`)
};

const pt_br2_cases_timeline_updated = /** @type {(inputs: Cases_Timeline_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualizado em ${i?.updated}`)
};

/**
* | output |
* | --- |
* | "Updated {updated}" |
*
* @param {Cases_Timeline_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_timeline_updated = /** @type {((inputs: Cases_Timeline_UpdatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Timeline_UpdatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_timeline_updated(inputs)
	return pt_br2_cases_timeline_updated(inputs)
});